import React, { Suspense } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
    AppBar,
    Box,
    CircularProgress,
    IconButton,
    Toolbar,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useSessionKeepAlive } from '../auth/useSessionKeepAlive';
import { REPORT_STUDIO_HEADER_PX } from '../pages/reports/reportStudioConstants';

const headerLogoUrl = `${process.env.PUBLIC_URL}/WhiteLogo.png`;

function studioTitle(pathname) {
    if (pathname.startsWith('/reports/designer/')) return 'Report Designer';
    return 'Reports';
}

/**
 * Full-viewport shell for the DevExpress report designer (no app nav).
 * DevExpress docs: pass explicit width/height on ReportDesigner; avoid nesting inside
 * overflow:hidden flex shells (AppLayout drawer + padding + toolbar spacer).
 */
export default function ReportStudioLayout() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useSessionKeepAlive();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100vh',
                overflow: 'hidden',
            }}
        >
            <AppBar position="static" elevation={1}>
                <Toolbar sx={{ minHeight: REPORT_STUDIO_HEADER_PX, gap: 1 }}>
                    <IconButton
                        color="inherit"
                        edge="start"
                        aria-label="Back to reports"
                        onClick={() => navigate('/reports')}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <Box
                        component="img"
                        src={headerLogoUrl}
                        alt="GenWeb"
                        sx={{
                            height: 40,
                            maxWidth: 140,
                            objectFit: 'contain',
                            flexShrink: 0,
                        }}
                    />

                    <Typography variant="h6" component="h1" sx={{ ml: 1 }}>
                        {studioTitle(pathname)}
                    </Typography>
                </Toolbar>
            </AppBar>

            <Box
                component="main"
                sx={{
                    flex: 1,
                    minHeight: 0,
                    minWidth: 0,
                    overflow: 'hidden',
                }}
            >
                <Suspense
                    fallback={
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    }
                >
                    <Outlet />
                </Suspense>
            </Box>
        </Box>
    );
}
